//collection
export const customers = "customers";
export const sessions = "sessions";

//storage
export const images = "images";
export const waivers = "waivers";
